/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'

import NProgress from 'nprogress';
import routes from './routes';
import store from '@/store';

Vue.use(VueRouter)

const router = new VueRouter({
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  if (to.params.locale) {
    const locales = {
      'ku': 'ku-Arab',
      'en': 'en',
      'ar': 'ar-SA'
    }
    if (['en', 'ku', 'ar'].indexOf(to.params.locale) != -1) {
      store.dispatch('locale/SET_LANGUAGE', to.params.locale);
      store.dispatch('locale/SET_API_LOCALE', locales[to.params.locale]);
    }
  }
  next()
})


router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
